import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { useHistory } from "react-router";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { useMutation } from "@/modules/api/hooks/useMutation";
import { apiErrorValidate } from "@/modules/api/utils/apiErrorValidate";
import { signInMutation } from "@/modules/auth/api/mutations/signIn/signInMutation";
import { useAuthContext } from "@/modules/auth/hooks/useAuthContext";
import { authenticatedRouting } from "@/modules/router/routings/authenticatedRouting";

const translationNamespace = "apiMessages/useSignInMutation";

export const useSignInMutation = () => {
  const auth = useAuthContext();
  const jsonApi = useJsonApi();
  const queryClient = useQueryClient();
  const history = useHistory();
  const { t } = useTranslation(translationNamespace);

  return useMutation([signInMutation.name], {
    mutationFn: signInMutation(jsonApi),
    onSuccess: async (response) => {
      if (response) {
        const { data } = response;
        auth.signIn({ id: data.relationships.user.data.id ?? "" });
        await queryClient.invalidateQueries([
          "user",
          data.relationships.user.data.id,
        ]);
        history.push(authenticatedRouting.buildUrl("tasks"));
      }
    },
    onError: (error: {
      response: {
        status: string;
      };
    }) => {
      apiErrorValidate(error, {
        401: {
          UNAUTHORIZED: t("You entered incorrect email and/or password"),
        },
        403: {
          FORBIDDEN: t("Account hasn't been confirmed"),
        },
      });
    },
    retry: false,
  });
};
